'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseGridCell = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { children , className , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement("td", _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-date-picker__grid-cell': true,
            [`${className}`]: !!className
        }),
        ref: ref,
        role: "gridcell"
    }), children);
});

exports.BaseGridCell = BaseGridCell;
//# sourceMappingURL=base-grid-cell.js.map
